import { computed } from 'vue'
import { DateTime } from 'luxon'
import { useNow } from '@/composables/game/time'

const phase2SnapshotTimestamp = DateTime.utc(2025, 12, 19, 18, 0, 0).toSeconds()

export const useSnapshot = () => {
  const { now } = useNow()

  const isAfterSnapshot = computed(() => now.value >= phase2SnapshotTimestamp)

  return {
    isAfterSnapshot,
    phase2SnapshotTimestamp,
  }
}
